import { CourseDef } from '../../../../types';
import L2926567 from './2926567';
import L2084298 from './2084298';
import L2084299 from './2084299';
import L2084309 from './2084309';
// import L5232745 from './5232745';
import L5232754 from './5232754';

export const masterclassAoVivo: CourseDef = {
  courseTitle: 'MASTERCLASS AO VIVO COM Gabriel Moreira TRADER',
  lessons: [L2926567, L2084298, L2084299, L2084309, 
    // L5232745, 
    L5232754],
};

